<template>
    <div class="table-layout mt10">
        <el-table :data="merchantQualiList" border style="width: 100%;height:400px;" @current-change="handleCurrentChange" empty-text="没有找到对应的资质，请先去申请资质认证">
            <el-table-column width="55">
                <template slot-scope="rows">
                    <div :class="{'copy-radio' : isSelectable(rows.row),  'circle' : isSelected(rows.row) }">
                        <div class="circle-dot"></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="qualiTypeName" label="资质名称" width="400" show-overflow-tooltip></el-table-column>
            <el-table-column prop="kindNmme" label="资质类型" align="left"></el-table-column>
            <el-table-column label="认证状态" width="250" align="center">
                <template slot-scope="rows">
                    <span v-if="rows.row.auditState == 1" class="font-green">已认证</span>
                    <span v-else class="font-red">认证未通过</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import merchtQualiApi from '../../api/merchtQuali'

    export default{
        name: 'swb-merchant-quali-for-select',
        desc: '选择商户资质',
        props: ['qualiTypeId'],
        data: function () {
            return {
                merchantQualiList: [],
                selectedId: null,
            }
        },
        created: function () {
            this.getMerchantQualiList();
        },
        methods: {
            // 商户所拥有的资质
            getMerchantQualiList: function () {
                let self = this;
                let postData = {};
                postData.qualiTypeId = self.qualiTypeId;
                merchtQualiApi.getMerchantQualiList(postData, function (result) {
                    if(result.type == 'info') {
                        let merchantQualiList = result.data;
                        for(let i = 0;i<merchantQualiList.length;i++){
                            let merchantQuali = merchantQualiList[i];
                            merchantQuali.kindNmme = getEnumInfoWith('qualiKind','value',merchantQuali.qualiKind).text;
                        }
                        self.merchantQualiList = merchantQualiList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //是否可选
            isSelectable(row){
                return row.auditState == 1;
            },
            //是否选中
            isSelected(row){
                return this.selectedId != null && this.selectedId == row.id;
            },
            handleCurrentChange: function (row) {
                if(this.isSelectable(row)) {
                    this.selectedId = row.id;
                }
            },
            getDlgResult: function () {
                let result = {};
                let selectedId = this.selectedId;
                if(selectedId != null) {
                    result.type = 'info';
                    result.merchantQuali = this.merchantQualiList.find(function (quali) {
                        return quali.id == selectedId;
                    });
                }
                else {
                    result.type = 'warn';
                    result.message = '请选择资质';
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/quali/MerchantQualiForSelect.vue